<script setup lang="ts">
import ServicesSlider from '~/components/homepage/services/components/servicesSlider/ServicesSlider.vue';
</script>

<template>
    <section id="services" class="services-section">
        <div class="services">
            <div class="services__title">
                <h3 class="services__caption">Услуги</h3>
            </div>

            <div class="services__content">
                <span class="services__headline">
                    Мы эксперты не только в разработке
                </span>
            </div>
        </div>

        <ServicesSlider />
    </section>
</template>

<style scoped lang="scss">
@import 'styles/services';
</style>
